import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    
    <header className="main-header">
      <div className="header-sticky">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container">

            {/* Logo */}
            <Link className="navbar-brand" to="/">
              <img
                src="/assets/images/healthtechlogo.png"
                alt="Logo"
                width="200"
              />
            </Link>

            {/* Toggle Button */}
            <button
              className="navbar-toggler"
              style={{color: '#069874'}}
              type="button"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-controls="mainNavbar"
              aria-expanded={menuOpen}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            {/* Menu */}
            <div
              className={`collapse navbar-collapse main-menu ${
                menuOpen ? "show" : ""
              }`}
              id="mainNavbar"
            >
              <div className="nav-menu-wrapper">
                <ul className="navbar-nav mr-auto" id="menu">
                  <li className="nav-item">
                    <Link className="nav-link" to="/">
                      Home
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/about-us">
                      About Us
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/services">
                      Services
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/blogs">
                      Blogs
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/contact-us">
                      Contact Us
                    </Link>
                  </li>

                  <li className="nav-item highlighted-menu">
                    <Link className="nav-link" to="/contact-us">
                      Free Consultation
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Right Button */}
              <div className="header-btn d-inline-flex">
                <Link to="/contact-us" className="btn-default">
                  Free Consultation
                </Link>
              </div>
            </div>

          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
